// utils/compressImage.ts
import imageCompression from "browser-image-compression";

export const compressImage = async (file: File): Promise<File> => {
  const options = {
    maxSizeMB: 0.3,        // Max 300KB
    maxWidthOrHeight: 1024, // Max 1024px width or height
    useWebWorker: true,     // Faster compression
    fileType: 'image/jpeg', // Convert to JPEG for better compression
  };

  try {
    const compressedFile = await imageCompression(file, options);
    return new File([compressedFile], file.name.replace(/\.[^/.]+$/, '.jpg'), {
      type: compressedFile.type,
    });
  } catch (error) {
    console.error('Image compression error:', error);
    return file; // Return original file if compression fails
  }
};